var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M14.516 18.894c2.307 0 4.177-1.812 4.177-4.047 0-2.235-1.87-4.047-4.177-4.047-2.306 0-4.176 1.812-4.176 4.047 0 2.235 1.87 4.047 4.176 4.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M20.982 15.074c0 3.46-2.894 6.263-6.464 6.263-3.57 0-6.465-2.804-6.465-6.263 0-.62.094-1.218.267-1.784H6.41v8.785c0 .455.372.826.827.826h14.481a.83.83 0 0 0 .828-.826V13.29h-1.831a6.09 6.09 0 0 1 .267 1.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M19.256 10.913h2.35a.938.938 0 0 0 .937-.936v-2.24a.938.938 0 0 0-.936-.937h-2.35a.939.939 0 0 0-.937.936v2.241c0 .515.421.936.936.936z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M28.612 14.891c0 7.793-6.317 14.111-14.11 14.111C6.707 29.002.39 22.685.39 14.892.39 7.097 6.708.78 14.501.78c7.794 0 14.111 6.318 14.111 14.111zM22.23 25.29c1.468 0 2.67-1.087 2.67-2.67V7.163c0-1.582-1.201-2.67-2.67-2.67H6.772c-1.468 0-2.67 1.088-2.67 2.67v15.459c0 1.582 1.202 2.669 2.67 2.669z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.65b3e93c5d30f9253875d3b52758c9ed.svg";
export { ForwardRef as ReactComponent };